module.exports = __webpack_public_path__ + "omniv2/img/icon-person-tick.acea67f6.svg";